import { create } from 'zustand';
import { persist } from 'zustand/middleware';

const quotaStore = (set) => ({
    quota: {},

    setUserQuota: (quota) => set({ quota })
});

const persistentStore = persist(quotaStore, { name: 'quota-user' });

export const useQuotaStore = create(persistentStore);

export default useQuotaStore;
